export enum ServiceCallStatus {
	Forbidden = 'forbidden',
}
